<template>
  <div class="mt-5 flex items-center rounded-sm bg-gray-100 p-2 text-gray-600">
    <ExclamationCircleIcon class="h-6 w-6 shrink-0" />
    <p class="ml-2 text-sm text-gray-800">
      <slot />
    </p>
  </div>
</template>

<script setup lang="ts">
import { ExclamationCircleIcon } from '@heroicons/vue/20/solid';
</script>
